import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { color } from 'styles/color.styles';
import { Tooltip } from '@material-ui/core';

export function BooleanIcon({
  condition,
  trueText = '',
  falseText = '',
  placement = 'top',
  iconSize = 24,
  tooltipClasses,
  iconClasses,
  showOnlyCheck
}) {
  return condition ? (
    <Tooltip title={trueText} placement={placement} classes={tooltipClasses}>
      <CheckIcon style={{ color: color.branding.green, fontSize: iconSize }} classes={iconClasses} />
    </Tooltip>
  ) : showOnlyCheck ? (
    ''
  ) : (
    <Tooltip title={falseText} placement={placement} classes={tooltipClasses}>
      <CloseIcon style={{ color: color.branding.red, fontSize: iconSize }} classes={iconClasses} />
    </Tooltip>
  );
}

BooleanIcon.propTypes = {
  condition: PropTypes.bool.isRequired,
  trueText: PropTypes.string,
  falseText: PropTypes.string,
  placement: PropTypes.string,
  iconSize: PropTypes.number,
  tooltipClasses: PropTypes.shape({
    tooltip: PropTypes.string
  }),
  iconClasses: PropTypes.shape({
    root: PropTypes.string
  }),
  showOnlyCheck: PropTypes.bool
};
